import React from 'react';
import { Button, Typography, Box, CircularProgress, FormControlLabel, Checkbox, Alert } from '@mui/material';
import { FileUploadArea } from 'app/components';
import { FileType } from 'app/components/FileUploadArea/FileUploadArea.types';
import { useIntl } from 'react-intl';
import { useNaverrekenenTemplateUploadPage } from './useNaverrekenenTemplateUploadPage';
import { SuccessDialog } from './components/SuccessDialog';

export const NaverrekenenTemplateUploadPage = () => {
  const intl = useIntl();
  const {
    MAX_FILE_SIZE,
    uploadedFile,
    isConfirmed,
    isLoading,
    error,
    showSuccessDialog,
    isUploadReady,
    handleFileUpload,
    handleConfirmationChange,
    handleUploadFile,
    handleSuccessDialogClose,
  } = useNaverrekenenTemplateUploadPage();

  return (
    <div>
      <Typography variant="h5" gutterBottom sx={{ my: 2 }}>
        {intl.formatMessage({ id: 'tools.naverrekenenTemplate.description' })}
      </Typography>

      <FileUploadArea
        maxSize={MAX_FILE_SIZE}
        onChange={handleFileUpload}
        types={[FileType.Excel]}
        filesLimit={1}
        showSuccessMessage={false}
        disabled={isLoading}
      />

      {uploadedFile && (
        <Box sx={{ mt: 3, mb: 2 }}>
          <FormControlLabel
            control={<Checkbox checked={isConfirmed} onChange={handleConfirmationChange} disabled={isLoading} />}
            label={intl.formatMessage({
              id: 'tools.naverrekenenTemplate.confirmCorrectFile',
            })}
          />
        </Box>
      )}

      {error && (
        <Box sx={{ mt: 2, mb: 2 }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      )}

      <Box sx={{ mt: 3, mb: 2 }}>
        <Button variant="contained" fullWidth size="large" onClick={handleUploadFile} disabled={!isUploadReady}>
          {intl.formatMessage({
            id: 'button.upload',
          })}
        </Button>
      </Box>

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4, gap: 2 }}>
          <CircularProgress size={50} />
          <Typography variant="h6">
            {intl.formatMessage({
              id: 'global.processing',
            })}
          </Typography>
        </Box>
      )}
      {/* Success Dialog */}
      <SuccessDialog open={showSuccessDialog} onClose={handleSuccessDialogClose} />
    </div>
  );
};
